import { baseValidators } from './builtins'
import { optionalValidators } from './optional'
import { OptionalValidatorKit, ValidatorKit } from './types'
import { Validator } from '../public'

/**
 * Exported namespace containing validators.
 */
export const v: ValidatorKit & { opt: OptionalValidatorKit, ignore: Validator } = {
  ...baseValidators,
  opt: optionalValidators,
  ignore: (value, field) => [{ valid: true, field: field ?? '', value }]
}